/**
 * アーカイブページ共通の初期化
 */
export function initArchive($) {
  // アクティブなメニュー項目を画面内に表示（即座に実行）
  setTimeout(function() {
    const activeMenuItem = document.querySelector('[class*="__menu-item--active"]');
    if (activeMenuItem) {
      // __menu-item ではなく __menu を探す（正規表現で厳密に）
      const menuContainer = activeMenuItem.closest('[class*="__menu"]:not([class*="__menu-"])');
      if (menuContainer) {
        // アクティブ項目の位置を取得
        const itemOffsetLeft = activeMenuItem.offsetLeft;
        const itemWidth = activeMenuItem.offsetWidth;
        const containerWidth = menuContainer.offsetWidth;

        // アクティブ項目を中央に配置
        const scrollLeft = itemOffsetLeft - (containerWidth / 2) + (itemWidth / 2);

        menuContainer.scrollLeft = scrollLeft;
      }
    }
  }, 200);

  if ($('body.archive').length === 0) return;

  // 検索条件やソート条件がある場合は、検索結果セクションへスクロール
  const urlParams = new URLSearchParams(window.location.search);

  // /page/2/ のようなページネーションパラメータも対象にする
  const pathParts = window.location.pathname
    .split('/')
    .filter((part) => part !== '');
  if (pathParts.includes('page')) {
    urlParams.append('page', pathParts[pathParts.indexOf('page') + 1] || '1');
  }

  // 検索条件やソート条件がある場合は、検索結果セクションへスクロール
  if (urlParams.size > 0) {

    // .xxxx__search-title までスクロールする。xxxxは各アーカイブ固有のクラス名で変動する
    const target = document.querySelector('[class*="__search-title"]');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }

  }
}
